import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getStatistics = createAsyncThunk('dashboard/statistics/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/get-statistics`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getTopCleanersGraph = createAsyncThunk('dashboard/get-top-cleaners-graph', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/get-top-cleaners-graph`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getTopClientsGraph = createAsyncThunk('dashboard/get-top-clients-graph', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/get-top-clients-graph`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getMostUsedCoupons = createAsyncThunk('dashboard/get-most-used-coupon', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/coupon/get-most-used-coupon`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allStatistics: [],
  allTopCleaners: [],
  allTopClients: [],
  mostUsedCouponData: {},
  error: null
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getStatistics.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getStatistics.fulfilled, (state, action) => {
        state.isLoading = false
        state.allStatistics = action.payload?.data?.data
      })
      .addCase(getStatistics.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getTopCleanersGraph.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getTopCleanersGraph.fulfilled, (state, action) => {
        state.isLoading = false
        state.allTopCleaners = action.payload?.data?.data
      })
      .addCase(getTopCleanersGraph.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getTopClientsGraph.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getTopClientsGraph.fulfilled, (state, action) => {
        state.isLoading = false
        state.allTopClients = action.payload?.data?.data
      })
      .addCase(getTopClientsGraph.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getMostUsedCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getMostUsedCoupons.fulfilled, (state, action) => {
        state.isLoading = false
        state.mostUsedCouponData = action.payload?.data?.data
      })
      .addCase(getMostUsedCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default dashboardSlice.reducer
